<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>


    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
        data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
        <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>About the post</h1>
                    </div>
                </div>
            </div>

        </div>

    </section>
    <!-- section close -->



    <div class="row notifi_main ">
        <div class="col-md-12">
            <h2>
                JVC's - CBT & PRACTICAL
            </h2>

            <!-- <p class="para_main_notify">
                The engagement of Junior Vocational Consultants
                (JVCs) for NSTIs to take care of Training of CTS courses along
                with New Age Courses (CTS) and High-End courses. (CTS)
            </p> -->
        </div>
    </div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="row sequence">


                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>For JVC  - 240 Posts                                    </h3>



                                    <p> <span class="step_no">1</span>CBT – 100 Marks – as per guidelines </p>
                                    <p> <span class="step_no">2</span> Duration: 1 ½ hours   </p>
                                    <p> <span class="step_no">3</span> Topic for CBT Proposed – Training Methodology, Employability Skills, Workshop Calculation & Science in the ratio of 20:20:10 
                                    </p>
                                    <p> <span class="step_no">4</span> Total questions – 50 with each 2 marks 
                                    </p>
                                  
                                    <!-- <p> <span class="step_no">5</span> The engagement is purely on temporary nature and
                                        the appointment can be cancelled
                                        at any time without providing any reason for it. </p>
                                    <p> <span class="step_no">6</span> The reservation policy applicable for Central
                                        Government services should be strictly
                                        followed in the selection process of JVCs
                                    </p>
                                    <p> <span class="step_no">7</span> An agreement on stamp paper of Rs.100 /- duly
                                        notarized, must be signed between the
                                        Director of the Institute and incumbent (Junior Vocational Consultant). </p>
                                    <p> <span class="step_no">8</span>A waitlist of qualified candidates (nearly 2 times
                                        the no. of vacancy of JVCs) is to be
                                        prepared & should kept in panel for three years. They will be considered against
                                        transfer, resignation, death etc. cases.</p> -->


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Consultant (IT & TS) - 78 posts (30 IT & 48 TS) </h3>
                                    <p> <span class="step_no">1</span>  CBT - 120 Marks - as per guidelines </p>
                                    <p> <span class="step_no">2</span> Duration 2 hours   </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Topic for consultant (IT)  </h3>
                                    <p> <span class="step_no">1</span>  English  Language - 15 questions </p>
                                    <p> <span class="step_no">2</span> Logical Reasoning - 15 questions </p>
                                    <p> <span class="step_no">3</span> Quantitative Aptitude & Data Interpretation  - 15 Marks  </p>
                                    <p> <span class="step_no">4</span>Computer Knowledge - 15 Marks </p>
                                    
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Topic for consultant (TS)  </h3>
                                    <p> <span class="step_no">1</span>  English  Language - 15 questions </p>
                                    <p> <span class="step_no">2</span> Logical Reasoning - 15 questions </p>
                                    <p> <span class="step_no">3</span> Quantitative Aptitude & Data Interpretation  - 15 Marks  </p>
                                    <p> <span class="step_no">4</span>Computer Knowledge - 15 Marks </p>
                                    
                                    <p> <span>Note: </span> No 4 Topic will be different only</p>
                                    <p> <span>Note: </span> Total Questions - 60 with each 2 marks
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                          <!-- feature box begin -->
                          <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Date of CBT Exam  - 14.09.2021  </h3>
                                    <p> <span class="step_no">1</span>  Hall ticket download - 06.09.2021 to 13.09.2021 </p>
                                    <!-- <p> <span class="step_no">2</span> Cut off ratio – 1:6 for both JVC & Consultant (IT & TS)  </p> -->
                                    <p> <span class="step_no">2</span> CBT result – 17.09.2021  </p>
                                  
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                                        <!-- feature box begin -->
                                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                                            <div class="feature-box style-2 left">
                                                <i class="fa fa-gavel"></i>
                                                <div class="text para_cls">
                                                    <h3>Date of Practical  Exam  - 24.09.2021  </h3>
                                                    <p> <span class="step_no">1</span>  Practical Exam - 100 Marks – JVC (as per guidelines) </p>
                                                    <p> <span class="step_no">2</span> Proof Skill test/interview - 30 Marks – consultant (IT & TS)  </p>

                                                  
                                                </div>
                                            </div>
                                        </div>
                                        <!-- feature box close -->

                        <!-- feature box begin -->



                     


      






                







                    </div>
                </div>

                <!-- <div class="col-md-4">
      <figure class="picframe invert transparent hover-shadow rounded">
                            <span class="overlay-v">
            <span class="v-center">
              <span>
                <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                  <span></span>
                </a>
              </span>
            </span>
          </span>
                        <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                    </figure>
    </div> -->
            </div>

        </div>
    </section>
    <!-- section close -->







</div>
<!-- content close -->




<style>
    #section-intro {
        background-image: url(assets/images/background/niminew.jpg);
        background-size: cover;
        background-position: 0% 0px;
        height: 80vh !important;
    }

    .notifi_main {
        text-align: center;
        padding: 40px 0px;
    }

    .notifi_main h2 {
        border-bottom: 6px solid #F56B55;
        width: fit-content;
        margin: 0 auto;
        padding: 0px 30px;
    }

    .notifi_main .descrip_cls {
        padding: 5px 0px;
        font-weight: 500;
        font-size: 21px;
    }

    .overlay-bg.t50 {
        background: rgba(30, 30, 30, .1);
    }

    table {
        width: 100%;
        margin-top: 10px;
    }

    th,
    td {
        padding: 10px;
    }

    thead {
        background-color: #F56B55;
        color: #fff;
    }

    tr:nth-child(odd) {
        background-color: #eee;
    }

    .step_no {
        left: 80px;
        height: 30px;
        width: 30px;
        background-color: #F56B55;
        border-radius: 50%;
        display: inline-block;
        font-size: 18px;
        text-align: center;
        color: #fff;
        margin-right: 10px;
        position: absolute;
    }

    .para_cls p {
        padding-left: 35px;
    }

    .num_marks {
        text-align: center;
    }

    .last_tr {
        background-color: #F56B55 !important;
        color: #fff;
    }

    .notifi_main_table h2 {

        width: fit-content;
        margin: 0 auto;
        padding: 50px 30px 10px;
        font-size: 23px;

    }

    .para_main_notify {
        padding: 20px 0px;
        width: 50%;
        margin: 0 auto;
    }

    #section-services {
        padding: 0px !important;
    }
</style>
